<template>
  <div class="d-flex text-left">
    <b-input-group class="panel-input-serach">
      <b-form-input
        id="statementNo-search"
        class="input-serach"
        placeholder="ค้นหาหมายเลขรายการ"
        v-model="searchStatementNo"
      ></b-form-input>
      <b-input-group-prepend>
        <span class="icon-input m-auto pr-2">
          <font-awesome-icon icon="search" title="View" @click="onSearchStatementNo" />
        </span>
      </b-input-group-prepend>
    </b-input-group>
    <b-dropdown
      id="dropdown-options"
      text="ตัวเลือกเพิ่มเติม"
      class="ml-2 dropdown-option"
    >
      <b-dropdown-item>
        <router-link to="/finance/create-finance/0?type=import" >
          นำเข้า ข้อมูล</router-link
        ></b-dropdown-item
      >
      <b-dropdown-item to="/finance/create-finance/0?type=order">เลือกรายการคำสั่งซื้อ(Omise)</b-dropdown-item>
    </b-dropdown>
    <b-button v-b-toggle.sidebar-filter class="btn-filter ml-2">
      <font-awesome-icon
        icon="filter"
        title="filter-btn"
        class="main-color mr-0 mr-sm-1"
      />
      <span class="d-none d-sm-inline">ตัวกรอง </span>
    </b-button>
    <b-sidebar
      id="sidebar-filter"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      ref="filterSidebar"
      aria-labelledby="sidebar-filter-title"
      no-header
    >
      <template #default="{ hide }">
        <div class="p-3 sidebar-filter-header d-flex justify-content-between">
          <h4 id="sidebar-filter-title" class="m-0">ตัวกรอง</h4>
          <font-awesome-icon
            class="my-auto"
            icon="times-circle"
            color="#FFFFFF"
            @click="hide"
          />
        </div>
        <div class="px-3 py-2">
          <div class="mt-2">
            <b-input-group class="panel-input-serach">
              <b-form-input
                id="product-search"
                class="input-serach"
                placeholder="ค้นหาชื่อหมายเลขคำสั่งซื้อ"
                v-model="filter.search"
              ></b-form-input>
              <b-input-group-prepend>
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon icon="search" title="View" />
                </span>
              </b-input-group-prepend>
            </b-input-group>
          </div>

          <div class="mt-3">
            <div class="font-weight-bold mb-2">วันทำรายการ (เริ่มต้น)</div>
            <div :class="['input-container']">
              <!-- <div
              :class="['input-container', { error: $v.form.startDate.$error }]"
            > -->
              <datetime
                :input-style="styleDatetime"
                v-model="filter.startDate"
                placeholder="วว / ดด / ปป"
                ref="startDate"
              >
              </datetime>
              <div
                class="icon-container text-right"
                @click="$refs.startDate.isOpen = true"
              >
                <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
              </div>
            </div>
          </div>

          <div class="mt-3">
            <div class="font-weight-bold mb-2">วันทำรายการ (สิ้นสุด)</div>
            <div :class="['input-container']">
              <!-- <div
              :class="['input-container', { error: $v.form.startDate.$error }]"
            > -->
              <datetime
                :input-style="styleDatetime"
                v-model="filter.endDate"
                placeholder="วว / ดด / ปป"
                ref="endDate"
              >
              </datetime>
              <div
                class="icon-container text-right"
                @click="$refs.endDate.isOpen = true"
              >
                <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
              </div>
            </div>
          </div>

          <div class="mt-3">
            <InputSelect
              title="ช่องทางการซื้อ"
              name="market"
              :options="marketList"
              valueField="value"
              textField="text"
              v-model="filter.market"
              @onDataChange="onMarketChange($event)"
            />
          </div>

          <div class="mt-3">
            <div class="font-weight-bold mb-2">สถานะธุรกรรม</div>
            <b-form-group>
              <div v-for="(item, i) in paymentStatus" :key="i">
                <b-form-checkbox
                  v-if="item.id === 0"
                  class="mb-2"
                  v-model="paymentStatusIdsAll"
                  >{{item.name}}</b-form-checkbox
                >
                <b-form-checkbox
                  v-else
                  :value="item.id"
                  class="mb-2"
                  v-model="filter.paymentStatusIds"
                  @change="checkSelect(item)"
                  >{{item.name}}</b-form-checkbox
                >
              </div>
            </b-form-group>
          </div>
        </div>
      </template>

      <template #footer>
        <div
          class="
            d-flex
            justify-content-between
            shadow
            align-items-center
            border-top
          "
        >
          <div class="w-100">
            <b-button
              @click="onClearFilter"
              block
              size="lg"
              variant="light"
              class="text-dark w-100 border-radius-0 btn-clear-filter"
              >ล้างตัวกรอง</b-button
            >
          </div>
          <div class="w-100">
            <b-button
              @click="onSubmitFilter"
              block
              size="lg"
              variant="light"
              class="text-body btn-main w-100 border-radius-0"
            >
              ยืนยัน
            </b-button>
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
export default {
  components: {
    InputSelect,
  },
  props: {
    paymentStatus: {
      required: false,
      type: Array
    },
    filter: {
      required: false,
      type: Object
    },
  },
  data() {
    return {
      searchStatementNo: "",
      paymentStatusIdsAll: false,
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      marketList: [],
    };
  },
  watch: {
    paymentStatusIdsAll (val) {
      if (val) {
        var newID = []
        for (let i = 0; i < this.paymentStatus.length; i++) {
          if (this.paymentStatus[i].id !== 0) {
            newID.push(this.paymentStatus[i].id) 
          }
        }
        this.filter.paymentStatusIds = newID
        console.log(this.filter.paymentStatusIds);
      } else if (val === false) {
        this.filter.paymentStatusIds = []
      }
    }
  },
  created() {
    this.getMarketList();
  },
  methods: {
    getMarketList () {
      this.axios.get(`${this.$baseUrl}/statement/salechannel`).then((response) => {
        if (response.result === 1) {
          this.marketList = response.detail
        }
      });
    },
    onMarketChange(value) {
      this.filter.market = value
    },
    checkSelect (item) {
      if (this.filter.paymentStatusIds.length === 0) {
        this.filter.paymentStatusIds.push(item.id)
      } else {
        const even = (element) => parseInt(element) === parseInt(item.id);
        var ischeck = this.filter.paymentStatusIds.some(even)
        const getIndex = (element) => parseInt(element) === parseInt(item.id);
        var idIndex = this.filter.paymentStatusIds.findIndex(getIndex)
        if (ischeck === false) {
          this.filter.paymentStatusIds.push(item.id)
        } else {
          this.filter.paymentStatusIds.splice(idIndex, 1)
          if (this.filter.paymentStatusIds.length === 1) {
            this.paymentStatusIdsAll = ""
          }
        }
      }
      if (this.filter.paymentStatusIds.length === 2) {
        this.paymentStatusIdsAll = true
      }
    },
    onClearFilter () {
      this.filter.search = ""
      this.filter.startDate = ""
      this.filter.endDate = ""
      this.filter.market = ""
      this.filter.paymentStatusIds = []
      this.paymentStatusIdsAll = false
      this.$emit("setFilter");
    },
    onSubmitFilter() {
      this.$emit("onSubmitFilter", this.filter);
      this.$refs.filterSidebar.hide();
    },
    onSearchStatementNo() {
      this.$emit("onSearchStatementNo", this.searchStatementNo);
    }
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}
.input-container.error {
  border-color: red !important;
}
a {
  color: #4f5d73 !important;
}
a:hover {
  text-decoration: none;
}
a:active {
    color: white !important;

}
</style>
